export class SegmentContinuity {
  averageContinuity: number;
  minimumContinuity: number;
  continuity: Map<string,string> = new Map();
}
